import { BOOKING_ASSIGN_TO_ME, BOOKING_ASSIGN_TO_ME_SUCCESS, BOOKING_ASSIGN_TO_ME_ERROR, BOOKING_ASSIGN_TO_ME_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const BookingAssignToMe = (state = initialState, action) => {
  switch (action.type) {
    case BOOKING_ASSIGN_TO_ME:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case BOOKING_ASSIGN_TO_ME_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case BOOKING_ASSIGN_TO_ME_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case BOOKING_ASSIGN_TO_ME_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default BookingAssignToMe;
